const CST_ADMINISTRATIONSERVICE_UI_URL = 'EENV_ADMSERVICE_API_URL';
const CST_ADMINISTRATIONSERVICE_API_URL = 'EENV_ADMSERVICE_API_URL/api';
const CST_SSOSERVICE_UI_URL = 'EENV_CST_SSOSERVICE_UI_URL';
const clientId = 'EENV_EKSERVICE_CI';
const clientSecret = 'EENV_EKSERVICE_CS';

export {
    clientId,
    clientSecret,
    CST_ADMINISTRATIONSERVICE_UI_URL,
    CST_ADMINISTRATIONSERVICE_API_URL,
    CST_SSOSERVICE_UI_URL
}
